export default {
  newStudent: {
    value: 1,
    name: '新生',
  },
  oldStudent: {
    value: 0,
    name: '老生',
  },
};

export function getCardIsNewName(value) {
  if (value === 1 || value === '1') return '新生';
  if (value === 0 || value === '0') return '老生';
  return '';
}
